import { useContext } from 'react';
import { VideoElContext } from '@embed/components/VideoPlayer/Player3/contexts/videoEl';
/**
 *
 */
export const useVideoEl = () => {
    const videoEl = useContext(VideoElContext);
    if (!videoEl) {
        throw new Error('Video element not found in the context');
    }
    return videoEl;
};
